import type { ElementType, ReactNode } from "react";

import { cn } from "@/lib/cn";

interface Props {
  children: ReactNode;
  className?: string;
  as?: ElementType;
}

export function Card({ children, className, as: As = "div" }: Props) {
  return <As className={cn("card p-4 sm:p-5", className)}>{children}</As>;
}
